import React, {Component, ReactNode} from 'react'
import { DialogContent, DialogTitle, DialogActions } from '@mui/material';
import styled from 'styled-components'
import {BelongCondominiumInfo} from '../../__NoAutomatedTests/components/login/repository/AdminUserLoginInfo'
import {Colors, FontWeights} from '../../styledComponents/Constants'
import {AdminPrimaryButton} from '../../styledComponents/adminPage/Buttons'
import {Nullable} from '../../app/TypeHelpers'
import {DialogCloseButton} from '../reservations/components/CommonStyle'
import {Close} from '@mui/icons-material'
import {ColumnFlexContainer, RowFlexContainer} from '../../styledComponents/FlexComponents'

interface Props {
    belongCondominiumInfoList: BelongCondominiumInfo[]
    handleCondominiumSelectButtonClick: (condominiumCd: string) => void
    handleCloseForCondominiumSelectDialog: () => void
}

interface Stats {
    selectedCondominiumCd: Nullable<string>
}

export default class AdminAssocCondominiumSelectionDialogSp extends Component<Props, Stats> {
    constructor(props: Props) {
        super(props)

        this.state = {
            selectedCondominiumCd: null,
        }
        this.onClickCondominiumSelectButton = this.onClickCondominiumSelectButton.bind(this)
        this.onClickCondominiumSelectionDecisionButton = this.onClickCondominiumSelectionDecisionButton.bind(this)
    }

    onClickCondominiumSelectButton(condminiumCd: string): void {
        this.setState({selectedCondominiumCd: condminiumCd})
    }

    onClickCondominiumSelectionDecisionButton(): void {
        if (this.state.selectedCondominiumCd) {
            this.props.handleCondominiumSelectButtonClick(this.state.selectedCondominiumCd)
        }
    }

    render(): ReactNode {
        const {belongCondominiumInfoList} = this.props
        const {selectedCondominiumCd} = this.state

        return <>
            <PanelArea>
                <SelectCondominiumDialogTitle>
                    <DialogTitle>物件選択</DialogTitle>
                    <DialogCloseButton onClick={this.props.handleCloseForCondominiumSelectDialog}>
                        <Close fontSize={'large'} style={{color: `${Colors.AccentDark}`}}/>
                    </DialogCloseButton>
                </SelectCondominiumDialogTitle>
                <SelectCondominiumDialogContent>
                    <SelectCondominiumInfo>ログインする物件を選択してください。</SelectCondominiumInfo>
                    {
                        belongCondominiumInfoList.map((belongCondominiumInfo) => (
                            <CondominiumCard
                                key={belongCondominiumInfo.condominiumCd}
                                $selectedflg={selectedCondominiumCd === belongCondominiumInfo.condominiumCd}
                                onClick={() => this.onClickCondominiumSelectButton(
                                    belongCondominiumInfo.condominiumCd)}
                            >
                                <div>{belongCondominiumInfo.condominiumName}</div>
                            </CondominiumCard>
                        ))
                    }
                </SelectCondominiumDialogContent>
                <SelectCondominiumDialogActions>
                    <CondominiumSelectionDecisionButton
                        disabled={this.state.selectedCondominiumCd === null}
                        onClick={this.onClickCondominiumSelectionDecisionButton}>
                        決定する
                    </CondominiumSelectionDecisionButton>
                </SelectCondominiumDialogActions>
            </PanelArea>
        </>
    }
}

const CondominiumCard = styled.div<{ $selectedflg: boolean }>`
    padding: 16px 8px;
    margin-top: 8px;
    width: 100%;
    font-weight: ${FontWeights.Bold};
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    background: #FFF;
    ${props => props.$selectedflg && `
        border: 1px solid ${Colors.AdminPrimary};
        background: rgba(63, 81, 181, 0.10);
   `}
`

const PanelArea = styled(ColumnFlexContainer)`
    height: 100%;
    align-items: stretch;
`

const SelectCondominiumDialogTitle = styled(RowFlexContainer)`
    font-weight: ${FontWeights.Bold};
    border-bottom: 1px solid #D9D9D9;
`

const SelectCondominiumDialogContent = styled(DialogContent)`
    &.MuiDialogContent-root {
        padding: 12px 16px 0 16px;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`
const SelectCondominiumDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 16px;
    }
`

const CondominiumSelectionDecisionButton = styled(AdminPrimaryButton)`
    width: 100%;
`

const SelectCondominiumInfo = styled.div `
    margin-bottom: 8px;
`
